import PlayIcon from "@redotech/redo-icons/play.svg";
import { Flex } from "@redotech/redo-web/flex";
import { memo } from "react";
import * as css from "./video-play-overlay.module.css";

export interface VideoPlayOverlayProps {
  /** Accessible name for the button, e.g. `Play ${title}`. */
  label: string;
  onPlay: () => void;
}

/**
 * Play affordance that fills its positioned parent, for videos that swap the
 * overlay out for an iframe once started.
 */
export const VideoPlayOverlay = memo(function VideoPlayOverlay({
  label,
  onPlay,
}: VideoPlayOverlayProps) {
  return (
    // design-allow: full-bleed play overlay; RedoButton can't cover the frame
    <button
      aria-label={label}
      className={css.playOverlay}
      onClick={onPlay}
      type="button"
    >
      <Flex align="center" height="full" justify="center" w="full">
        <Flex
          align="center"
          borderRadius="full"
          className={css.playCircle}
          justify="center"
          shadow="lg"
        >
          <PlayIcon className={css.playIcon} />
        </Flex>
      </Flex>
    </button>
  );
});
